var React = require('react');

function NavOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7 27v-2h26v2zm0-6v-2h26v2zm0-6v-2h26v2z","fillRule":"evenodd"}));
}

NavOpen.defaultProps = {"viewBox":"10 10 20 20"};

module.exports = NavOpen;

NavOpen.default = NavOpen;
